import React, { useEffect, useState } from "react";
import styles from '../styles/Unitieup.module.scss';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import CustomImage from "./CustomImage";
import Link from "next/link";
import fetchUtil from "../utils/fetchUtil";


const TopTieUpsOfKC: React.FC = () => {
  const [topTieUps, setTopTieUps] = useState<any>({})

  useEffect(() => {
    fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/top-university-tie-ups`, 'GET', {}, '', false)
      .then((res: any) => setTopTieUps(res))
  }, [])

  return (
    topTieUps
      ? <div id="uni-tie-upmain" className={styles.uniTieUp}>
        <Container>
          <Row>
            <div id="unitieuptxt" className={`text-center ${styles.heading}`}>
              <div className={styles.uniDiv}>
                <h2>{topTieUps?.title}</h2>
                <p>{topTieUps?.description}</p>
              </div>
            </div>
          </Row>
          <Row id="unitieupLogo" className="text-center">
            {
              topTieUps?.images?.length > 0 &&
              topTieUps.images.map((images: any, index: number) => {
                return (
                  <Col xl={3} md={3} xs={6} className={`${styles.cols} ${index > 3 ? styles.borderl0 : ''}`} key={index}>
                    <div className={styles.unidiv}>
                      <CustomImage src={images?.imageUrl} alt={images?.imageAltTag} width={174} height={75} />
                    </div>
                  </Col>
                )
              })
            }
          </Row>
          <div className="text-center mt-3">
            <Link href={'/universities'}><a id="moreUniId" className={styles.viewMore}>More Universities</a></Link>
          </div>
        </Container>
      </div>
      : null
  )
}

export default TopTieUpsOfKC;